/* eslint-disable react-hooks/exhaustive-deps */
import { AlertTost, CustomInput, CustomPhoneInput } from "#components";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import { WebLayout } from "#layouts";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { profileInitialValues } from "#validations/initialValues.js";
import { profileValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileSkeleton from "../../skeleton/profileSkeleton";
import { NotFound } from "#UI";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import usePost from "#hooks/usePost.js";

const ProfileScreen = () => {
  const [profileImg, setProfileImg] = useState(null);
  const profileImgRef = useRef(null);
  const { data: profileData, isLoading: isProfileLoading } = useGet(
    ENDPOINTS.GET_PROFILE,
    QUERY_KEYS.GET_PROFILE_QUERY_KEY
  );
  const {
    mutateAsync: editProfileMutateAsync,
    isLoading: isLoadingEditProfile,
  } = usePost(ENDPOINTS.EDIT_PROFILE, QUERY_KEYS.EDIT_PROFILE_QUERY_KEY);

  const nav = useNavigate();

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: profileInitialValues,
    validationSchema: profileValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("firstName", values?.firstName);
      formData.append("lastName", values?.lastName);
      formData.append("location", values?.location);
      formData.append("image", values?.profileImage);
      try {
        const response = await editProfileMutateAsync(formData);
        nav(WebRoutePath.DASHBOARD.path);
        AlertTost(response?.message, "success");
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });
  const profileImageUpload = (target) => {
    const file = target.files[0];
    if (file) {
      setFieldValue("profileImage", file);
      const previewUrl = URL.createObjectURL(file);
      setProfileImg(previewUrl);
    }
  };

  const handelSelectProfile = () => {
    if (profileImgRef.current) {
      profileImgRef.current.click();
    }
  };

  useEffect(() => {
    setValues(
      {
        countryCode: profileData?.data?.countryCode,
        phoneNumber: profileData?.data?.phoneNumber,
        emailAddress: profileData?.data?.email,
        firstName: profileData?.data?.firstName,
        lastName: profileData?.data?.lastName,
        location: profileData?.data?.location,
        profileImage: profileData?.data?.image,
      },
      setProfileImg(profileData?.data?.image)
    );
  }, [profileData?.data]);
  if (isProfileLoading) {
    return (
      <WebLayout>
        <ProfileSkeleton />
      </WebLayout>
    );
  }
  if (!profileData?.data) {
    return (
      <WebLayout>
        <NotFound title="Profile not found" />
      </WebLayout>
    );
  }

  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form
                className="detail_card_wrapper profile_card_wrapper"
                onSubmit={handleSubmit}
              >
                <div className="profile-detail-wrapper d-flex justify-content-end align-items-center">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="profile-blk position-relative">
                      <div className="profile_upload">
                        <img
                          src={profileImg ? profileImg : ImagesUrl.noProfile}
                          alt="Profile"
                        />

                        <input
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={profileImgRef}
                          onChange={({ target }) => profileImageUpload(target)}
                        />
                        <label
                          htmlFor="profileUpload"
                          onClick={handelSelectProfile}
                        >
                          <img src={ImagesUrl.addPhoto} alt="add-icon" />
                        </label>
                      </div>

                      <div className="profile_info">
                        <span className="user_name">{`${profileData?.data?.firstName} ${profileData?.data?.lastName}`}</span>
                        <span className="user_email">
                          {profileData?.data?.email}
                        </span>
                      </div>
                      {errors.profileImage && touched.profileImage && (
                        <p
                          style={{
                            color: "red",
                            marginBottom: 0,
                            position: "absolute",
                            top: "85px",
                          }}
                        >
                          {errors.profileImage}
                        </p>
                      )}
                    </div>

                    <div className="d-flex gap-3">
                      <button
                        className="secondary-btn py-2 w-auto"
                        type="button"
                        onClick={() => nav(-1)}
                      >
                        Cancel
                      </button>
                      <button
                        className="primary-btn py-2 w-auto"
                        disabled={isLoadingEditProfile}
                      >
                        {isLoadingEditProfile ? (
                          <ClipLoader size={17} color="#fff" />
                        ) : (
                          "Edit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row g-4">
                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        label="First Name"
                        type="text"
                        placeholder="Enter your First Name"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.firstName}
                        touched={touched.firstName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        label="Last Name"
                        type="text"
                        placeholder="Enter your Last Name"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.lastName}
                        touched={touched.lastName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        readOnly={true}
                        label="Email Address"
                        type="text"
                        placeholder="Enter your Email Address"
                        name="emailAddress"
                        value={values.emailAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.emailAddress}
                        touched={touched.emailAddress}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomPhoneInput
                        label="Phone number"
                        disabled={true}
                        error={errors.phoneNumber}
                        touched={touched.phoneNumber}
                        countryCode={values.countryCode}
                        phoneNumber={values.phoneNumber}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        label="Location"
                        type="text"
                        placeholder="Enter your Location"
                        name="location"
                        value={values.location}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.location}
                        touched={touched.location}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default ProfileScreen;
